<div class="row">
  <div class="col">
    <div #contentElement data-id='scrollable_table' class="mt-4">
      <!-- Small screens - WITH horizontal scroller -->
      <c11n-data-table-horizontal-scroller
        c11n-horizontal-scroller-sticky-header
        class="c11n-table__tr"
        [stickyOnScroll]="false"
        [verticalOffset]="0"
        [numberStickyColumns]="0">
        <!-- Table MUST be direct child of scroller -->

        <table id="statements-list-table" c11n-data-table
               [size]="'medium'"
               [stickyHeader]="false"
               [zebraStriping]="false"
               [verticalAlign]="'middle'"
               [rowHighlight]="true"
               [headerDividers]="true"
               [stickyFirstColumn]="false"
               class="c11n-space-stack-4x numeric-data">
          <caption c11n-table-caption [alignBottom]="true" class="sr-only"></caption>
          <thead>
          <tr c11n-thead-tr>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'select_radio'"
            >
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'message_number'">
              <span class="text-nowrap d-block">Message</span>
              <span class="text-nowrap d-block">number</span>
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'msg_v'">
              <span class="text-nowrap d-block">MSG</span>
              <span class="text-nowrap d-block">V</span>
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'message'"
                scope="col">
              First line of message
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'message_type'"
            >
              Message type
              <!--<span class="text-nowrap d-block">type</span>-->
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'permanent'"
            >
              Permanent<!--<span class="text-nowrap">Permanent</span>-->
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'last_updated'"
            >
              Last updated
              <!--<span class="text-nowrap d-block">updated</span>-->
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'priority'"
            >
              Priority<!--<span class="text-nowrap">Priority</span>-->
            </th>
            <th c11n-thead-th [alignment]="'left'" [cellName]="'att_v'"
            >
              <span class="text-nowrap d-block">Att</span>
              <span class="text-nowrap d-block">V</span>
            </th>
          </tr>
          </thead>
          <tbody>
         <tr c11n-tbody-tr *ngIf="errorMessage">
            <td c11n-tbody-td [colspan]="'9'">
           <c11n-banner [variant]="'warning'"
                        (closeEvent)="clearErrorMessage()"
                        [hasCloseControl]="true"
                        [size]="'small'">{{errorMessage}}</c11n-banner>
            </td>
         </tr>
          <tr c11n-tbody-tr *ngFor="let message of paginatingTableDataSlice;let i = index;">
            <td c11n-tbody-td [alignment]="'center'">
              <c11n-radio [hideLabel]="true" (stateChange)="messageDetailSelection($event, message)">
                <input c11nRadioInput
                       type="radio"
                       [id]="'message-large-' + message.messageId"
                       name="message-selection-large"
                       [value]="message.messageId"
                       [attr.aria-label]="'Select message ' + message.messageText"
                />
              </c11n-radio>
            </td>
            <td c11n-tbody-td [alignment]="'left'">{{ message.messageId }}</td>
            <td c11n-tbody-td [alignment]="'left'">{{ message.verifyFlag | yesNo }}</td>
            <td c11n-tbody-td class="text-break" [alignment]="'left'">{{ message.messageText | limitedChars}}</td>
            <td c11n-tbody-td [alignment]="'left'">{{ message.messageType | limitedChars: MESSAGE_TYPE_LIMIT }}</td>
            <td c11n-tbody-td [alignment]="'left'">{{ message.permanentMessageFlag | yesNo }}</td>
            <td c11n-tbody-td [alignment]="'left'">{{ message.lastUpdatedTimestamp | date: 'MM/dd/yyyy hh:mm:ss a' }}</td>
            <td c11n-tbody-td [alignment]="'left'">—</td>
            <td c11n-tbody-td [alignment]="'left'">—</td>
          </tr>
          </tbody>
        </table>
          <c11n-pagination class="pagination-control" *ngIf="data.length"
                           [variant]="'unNumbered'"
                           [descriptiveLabel]="dataRangeText"
                           [totalNumberOfItems]="data.length"
                           [itemsPerPage]="itemsPerPage"
                           [firstAndLastOption]="'caretLink'"
                           [activePage]="currentPage"
                           [hideControlsWithNoResults]="true"
                           (activeItemChange)="handlePageChange($event)"
          ></c11n-pagination>
      </c11n-data-table-horizontal-scroller>
    </div>
  </div>
</div>
